// Decoupled notifier for an invalid admin session (HTTP 401).
//
// axiosApi emits an "unauthorized" event; the store layer subscribes and
// decides what to do. This keeps axiosApi free of any Redux/store import,
// so no circular dependency is created between the API layer and the store.

let handler = null;

export const onUnauthorized = (callback) => {
    handler = callback;
};

export const emitUnauthorized = () => {
    if (handler) {
        handler();
    }
};
